import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api'
import React, { useEffect, useRef, useState } from 'react'
import { GOOGLE_MAPS_LOADER_OPTIONS } from './map/MapGisTools'
import { useMapsUnavailable, MapUnavailable } from './map/MapUnavailable'

const MyGoogleMap = ({ markerPins = [], center = {}, containerStyle = {}, trackedUser }) => {
  const { isLoaded } = useJsApiLoader(GOOGLE_MAPS_LOADER_OPTIONS);
  const mapsUnavailable = useMapsUnavailable();
  const wrapperRef = useRef(null);
  const [ready, setReady] = useState(false);

  // Only mount <GoogleMap> once the wrapper is attached AND has a non-zero
  // layout box. Google Maps registers an IntersectionObserver on the map
  // container at construction time; if it runs while the container is still
  // 0x0 (e.g. inside an animating/scrolling modal), it throws
  // "IntersectionObserver.observe ... parameter 1 is not of type 'Element'".
  useEffect(() => {
    if (!isLoaded) { setReady(false); return; }
    let raf;
    const check = () => {
      const el = wrapperRef.current;
      if (el && el.offsetWidth > 0 && el.offsetHeight > 0) {
        setReady(true);
      } else {
        raf = requestAnimationFrame(check);
      }
    };
    raf = requestAnimationFrame(check);
    return () => raf && cancelAnimationFrame(raf);
  }, [isLoaded]);

  return (
    <div ref={wrapperRef} style={{ width: '100%', height: '100%', ...containerStyle }}>
      {mapsUnavailable ? (
        <MapUnavailable center={center} setGpsHref="/locations-zones" />
      ) : (!isLoaded || !ready) ? (
        <div className="flex items-center justify-center text-gray-400 text-sm" style={{ width: '100%', height: '100%' }}>
          Loading map…
        </div>
      ) : (
        <GoogleMap
          mapContainerStyle={{ width: '100%', height: '100%' }}
          center={center}
          zoom={15}
        >
          {markerPins.map((item, i) => (
            <Marker key={i} position={item} />
          ))}

          {/* Live Tracked User Marker */}
          {trackedUser && trackedUser.lat && trackedUser.lng && (
            <Marker
              position={{ lat: Number(trackedUser.lat), lng: Number(trackedUser.lng) }}
              title={trackedUser.userName}
              icon={{
                url: "https://maps.google.com/mapfiles/ms/icons/blue-dot.png"
              }}
              zIndex={1000}
            />
          )}
        </GoogleMap>
      )}
    </div>
  )
}

export default MyGoogleMap
